// oauthClients.js — chargement à la demande des SDK Google/Facebook pour récupérer un token OAuth,
// transmis ensuite à Nakama (authenticateGoogle/Facebook). Inactif tant que les client IDs
// ne sont pas fournis (REACT_APP_GOOGLE_CLIENT_ID / REACT_APP_FACEBOOK_APP_ID).
import { socialAuth } from '../config/socialAuth';

function loadScript(src, id) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve();
    const s = document.createElement('script');
    s.src = src; s.id = id; s.async = true; s.defer = true;
    s.onload = () => resolve(); s.onerror = () => reject(new Error('script'));
    document.head.appendChild(s);
  });
}

// Décode le champ « name » d'un ID token Google (JWT) pour dériver un pseudo normalisé.
function jwtName(token) {
  try {
    const p = JSON.parse(atob(String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return p.name || p.given_name || (p.email ? p.email.split('@')[0] : null);
  } catch { return null; }
}

// Google Identity Services → { token: ID token (JWT), name } accepté par Nakama authenticateGoogle.
export async function loadGoogleToken() {
  if (!socialAuth.google.enabled) throw new Error('google-disabled');
  await loadScript('https://accounts.google.com/gsi/client', 'gsi-client');
  return new Promise((resolve, reject) => {
    try {
      /* global google */
      google.accounts.id.initialize({
        client_id: socialAuth.google.clientId,
        callback: (resp) => resp && resp.credential
          ? resolve({ token: resp.credential, name: jwtName(resp.credential) })
          : reject(new Error('no-credential')),
      });
      google.accounts.id.prompt(); // affiche l'invite de connexion Google
    } catch (e) { reject(e); }
  });
}

// Facebook Login → renvoie un access token accepté par Nakama authenticateFacebook.
export async function loadFacebookToken() {
  if (!socialAuth.facebook.enabled) throw new Error('facebook-disabled');
  await loadScript('https://connect.facebook.net/fr_FR/sdk.js', 'fb-sdk');
  return new Promise((resolve, reject) => {
    try {
      /* global FB */
      FB.init({ appId: socialAuth.facebook.appId, cookie: true, xfbml: false, version: 'v19.0' });
      // public_profile + email. NB: `email` pour des utilisateurs PUBLICS exige l'accès avancé
      // Meta (vérification d'entreprise/individuelle + App Review). Si non accordé, Meta ignore
      // simplement `email` (le login marche quand même, sans l'e-mail) — dégradation propre.
      FB.login((r) => {
        if (r && r.authResponse && r.authResponse.accessToken) {
          const token = r.authResponse.accessToken;
          // Récupère le nom du profil pour dériver un pseudo normalisé (public_profile suffit).
          try { FB.api('/me', { fields: 'name' }, (me) => resolve({ token, name: (me && me.name) || null })); }
          catch { resolve({ token, name: null }); }
        } else reject(new Error('fb-cancelled'));
      }, { scope: 'public_profile,email' });
    } catch (e) { reject(e); }
  });
}
